export const isOrderedShowcaseRow = (row = {}) =>
  row?.description?.trim?.().toLowerCase() === "ordered";

const getPriorityMap = (contentKeys = []) => {
  const priorityMap = new Map();

  contentKeys.forEach((entry) => {
    if (!entry?.contentKey) return;
    const priority = Number(entry.priority);
    if (!Number.isFinite(priority)) return;
    priorityMap.set(String(entry.contentKey), priority);
  });

  return priorityMap;
};

const getItemMatchKeys = (item = {}) => {
  const content = item?.content || {};

  return [
    item?.contentKey,
    content?.contentKey,
    item?.slug,
    content?.slug,
    item?._id,
    content?._id,
  ]
    .filter((value) => value !== null && value !== undefined && value !== "")
    .map(String);
};

const getItemPriority = (item, priorityMap) => {
  const matchKeys = getItemMatchKeys(item);

  for (const key of matchKeys) {
    if (priorityMap.has(key)) return priorityMap.get(key);
  }

  return null;
};

export const sortShowcaseItemsForRow = (row = {}, items = []) => {
  if (!Array.isArray(items) || !isOrderedShowcaseRow(row)) return items;

  const priorityMap = getPriorityMap(row.contentKeys);
  if (priorityMap.size === 0) return items;

  return [...items].sort((a, b) => {
    const aPriority = getItemPriority(a, priorityMap);
    const bPriority = getItemPriority(b, priorityMap);

    if (aPriority !== null && bPriority !== null) return aPriority - bPriority;
    if (aPriority !== null) return -1;
    if (bPriority !== null) return 1;
    return 0;
  });
};
